/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { doctordashboardprofile06 } from "../../imagepath";
import { AuthContext } from "../../../context/AuthContext";
import { getCurrentUser } from "../../../services/authService";

export const DashboardSidebar = () => {
  const pathnames = window.location.pathname;
  const { user, logout } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [age, setAge] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Get user data from localStorage or context
    const currentUser = getCurrentUser();
    if (currentUser) {
      setUserData(currentUser);

      // Calculate age from DOB
      if (currentUser.dob) {
        const birthDate = new Date(currentUser.dob);
        const today = new Date();
        const calculatedAge = today.getFullYear() - birthDate.getFullYear();
        setAge(calculatedAge);
      }
    }
  }, [user]); // Re-run when user context changes

  const handleLogout = () => {
    logout();
    navigate('/'); // Redirect to home after logout
  };

  // Function to handle image loading errors
  const handleImageError = (e) => {
    console.log("Image failed to load, using fallback image");
    e.target.src = doctordashboardprofile06; // Fallback to default image
  };

  return (
    <>
      {/* Profile Sidebar */}
      <div className="profile-sidebar doctor-sidebar profile-sidebar-new">
        <div className="widget-profile pro-widget-content">
          <div className="profile-info-widget">
            <Link to="#" className="booking-doc-img">
              <img
                src={userData?.profilepicture || doctordashboardprofile06}
                alt="User Image"
                onError={handleImageError}
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '50%'
                }}
              />
            </Link>
            <div className="profile-det-info">
              <h3>
                <Link to="#">{userData?.fullName || "User"}</Link>
              </h3>
              <div className="patient-details">
                <h5 className="mb-0">Fan ID : {userData?.userId ? `FN${userData.userId.slice(-6).toUpperCase()}` : "FN000234"}</h5>
              </div>
              <span>
                Age <i className="fa-solid fa-circle" />
                {age ? ` ${age} years` : " Age not set"}
              </span>
            </div>
          </div>
        </div>
        <div className="dashboard-widget">
          <nav className="dashboard-menu">
            <ul>
              <li className={pathnames.includes('/fan-dashboard') ? 'active' : ''}>
                <Link to="/fan-dashboard">
                  <i className="isax isax-category-2"></i>
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className={pathnames.includes('/fan-account') ? 'active' : ''}>
                <Link to="/fan-account">
                  <i className="isax isax-wallet-2"></i>
                  <span>Wallet</span>
                </Link>
              </li>
              <li className={pathnames.includes('/order') ? 'active' : ''}>
                <Link to="/order">
                  <i className="isax isax-calendar-1"></i>
                  <span>My Orders</span>
                </Link>
              </li>
              <li className={pathnames.includes('/profile') ? 'active' : ''}>
                <Link to="/profile2">
                  <i className="isax isax-setting-2"></i>
                  <span>Profile Settings</span>
                </Link>
              </li>
              <li>
                <Link to="/" onClick={handleLogout}>
                  <i className="isax isax-logout"></i>
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {/* /Profile Sidebar */}
    </>
  );
};

export default DashboardSidebar;
